module.exports = __webpack_public_path__ + "media/scss/webfonts/384AEE_0_0-0aa39f7b4480f266a8c65ee2f70e16dd.woff2";